import React, { FunctionComponent, useEffect, useMemo } from 'react';
import { StrictReactNode } from 'record-it-components/types/StrictReactNode';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { StorageClearer } from '../classes/StorageClearer/StorageClearer';
import { StopwatchManager } from '../classes/timeTracking/StopwatchManager/StopwatchManager';
import {
  StopwatchManagerContext,
  StopwatchManagerContextValue
} from '../context/StopwatchManagerContext';
import { useInitializable } from '../hooks/useInitializable/useInitializable';

export const AppStopwatchManagerContextProvider: FunctionComponent<{
  children: StrictReactNode;
}> = React.memo((props) => {
  const { children } = prepareProps({ props });

  const { initializable: stopwatchManager } = useInitializable({
    createInstance: () => new StopwatchManager()
  });

  useEffect(() => {
    const disposable = StorageClearer.registerAfterClearTask(() =>
      stopwatchManager?.clear()
    );

    return () => {
      disposable.dispose();
    };
  }, [stopwatchManager]);

  const contextValue: StopwatchManagerContextValue | null = useMemo(() => {
    return stopwatchManager ? { stopwatchManager } : null;
  }, [stopwatchManager]);

  if (!contextValue) {
    return <div>Intializing StopwatchManager..</div>;
  }

  return (
    <StopwatchManagerContext.Provider value={contextValue}>
      {children}
    </StopwatchManagerContext.Provider>
  );
});
